import { Component, Input, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { LayoutSidebarService, SidebarSide } from '../../services/sidebar.service';

@Component({
  selector: 'uex-layout-sidebar-toggler',
  templateUrl: './toggler.component.html'
})
export class LayoutSidebarTogglerComponent implements OnInit {
  @Input('sidebar') private _sidebar_side: SidebarSide = 'left';

  constructor(
    private _sidebarService: LayoutSidebarService
  ) { }

  public has_side_bar = false;

  private _register_sidebar_subscription: Subscription;
  private _unregister_sidebar_subscription: Subscription;

  public ngOnInit() {
    this._setHasSideBar();

    this._register_sidebar_subscription = this._sidebarService.onSideBarRegister.subscribe(() => this._setHasSideBar());
    this._unregister_sidebar_subscription = this._sidebarService.onSideBarUnregister.subscribe(() => this._setHasSideBar());
  }

  public ngOnDestroy() {
    if (this._register_sidebar_subscription) { this._register_sidebar_subscription.unsubscribe(); }
    if (this._unregister_sidebar_subscription) { this._unregister_sidebar_subscription.unsubscribe(); }
  }

  public toggleVisible() {
    this._sidebarService.toggleVisible(this._sidebar_side);
  }

  private _setHasSideBar() {
    setTimeout(() => {
      this.has_side_bar = !!this._sidebarService.getSidebar(this._sidebar_side);
    }, 0);
  }
}
